import _ from "lodash";
import {
  DEFAULT_NAME_ORDER_PREFERENCE,
  FULL_NAME,
  FIRST_NAME,
  LAST_NAME,
} from "Constants/stringConstants";
import { getDefaultStudentNameOrderPreference } from "./GetFormattedStudentName";
import { getCleanNameOption } from "./GetCleanNameOption";
import {
  ENABLE_STUDENT_MIDDLE_NAME,
  ENABLE_USER_MIDDLE_NAME,
} from "Constants/permissionConstants";

import ACLStore from "lib/aclStore";

export const getStudentSortByList = ({ sortList = [], keyToMap = "" }) => {
  const isStudentMiddleNameEnabled = ACLStore.can(ENABLE_STUDENT_MIDDLE_NAME);
  const isUserMiddleNameEnabled = ACLStore.can(ENABLE_USER_MIDDLE_NAME);

  const defaultNameOrder = getDefaultStudentNameOrderPreference();
  const cleanNameOrder = _.map(defaultNameOrder, option =>
    getCleanNameOption(option, true)
  );
  const NAME_ORDER_PREFERENCE = [FULL_NAME];
  if (_.includes(cleanNameOrder, FIRST_NAME)) {
    NAME_ORDER_PREFERENCE.push(FIRST_NAME);
  }
  if (_.includes(cleanNameOrder, LAST_NAME)) {
    NAME_ORDER_PREFERENCE.push(LAST_NAME);
  }

  const studentNameOrderPreference =
    isStudentMiddleNameEnabled || isUserMiddleNameEnabled
      ? NAME_ORDER_PREFERENCE
      : DEFAULT_NAME_ORDER_PREFERENCE;
  let updatedSortList = sortList;
  updatedSortList = _.filter(sortList, sortItem =>
    _.includes(studentNameOrderPreference, _.get(sortItem, keyToMap))
  );
  updatedSortList = _.sortBy(updatedSortList, sortItem =>
    _.findIndex(
      studentNameOrderPreference,
      key => key === _.get(sortItem, keyToMap)
    )
  );
  return updatedSortList;
};
